import { render, staticRenderFns } from "./SearchIngredients.vue?vue&type=template&id=8de94f9c&scoped=true"
import script from "./SearchIngredients.vue?vue&type=script&lang=js"
export * from "./SearchIngredients.vue?vue&type=script&lang=js"
import style0 from "./SearchIngredients.vue?vue&type=style&index=0&id=8de94f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de94f9c",
  null
  
)

export default component.exports